var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { position: "relative" } },
    [
      _vm.isLoading
        ? _c(
            "v-layout",
            {
              staticStyle: {
                position: "absolute",
                top: "0",
                left: "0",
                right: "0",
                bottom: "0",
                "z-index": "1000",
                background: "rgba(255, 255, 255, .95)"
              },
              attrs: { "align-center": "", "justify-center": "" }
            },
            [
              _c("div", { staticClass: "primary--text" }, [
                _c("div", { staticClass: "lds-roller" }, [
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div")
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("Patientez SVP ...")])
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { wrap: "", "mx-1": "", "pb-4": "" } },
        [
          _c(
            "v-flex",
            { staticClass: "form-section", attrs: { xs12: "", md4: "" } },
            [
              _c(
                "div",
                { staticClass: "mx-3" },
                [
                  _c(
                    "v-flex",
                    { attrs: { "mb-3": "" } },
                    [
                      _c("v-layout", { staticClass: "title--text-custom" }, [
                        _c("div", { staticClass: "primary--text" }, [
                          _vm._v("1")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "secondary--text" }, [
                          _vm._v(".")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("h1", { staticClass: "primary--text" }, [
                        _vm._v("Informations générales")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "base-control-label-vertical",
                    {
                      attrs: {
                        required: "",
                        label: _vm.lblSetting.labelTemplateMaintenanceName
                      }
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          counter: _vm.textConfigs.input,
                          maxlength: _vm.textConfigs.input,
                          required: "",
                          rules: _vm.dtRules.nameRules,
                          solo: ""
                        },
                        model: {
                          value: _vm.name,
                          callback: function($$v) {
                            _vm.name = $$v
                          },
                          expression: "name"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "base-control-label-vertical",
                    {
                      attrs: {
                        required: "",
                        label:
                          _vm.lblSetting.labelTemplateMaintenanceDescription
                      }
                    },
                    [
                      _c("v-textarea", {
                        attrs: {
                          name: "description",
                          counter: _vm.textConfigs.textarea,
                          maxlength: _vm.textConfigs.textarea,
                          rows: 4,
                          required: "",
                          solo: "",
                          rules: _vm.dtRules.descriptionRules
                        },
                        model: {
                          value: _vm.description,
                          callback: function($$v) {
                            _vm.description = $$v
                          },
                          expression: "description"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "base-control-label-vertical",
                    { attrs: { label: _vm.lblSetting.labelMaintenanceType } },
                    [
                      _c("ticket-group-round-buttons", {
                        attrs: { buttons: _vm.coTypes },
                        model: {
                          value: _vm.type,
                          callback: function($$v) {
                            _vm.type = $$v
                          },
                          expression: "type"
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticStyle: { height: "10px" } })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            {
              staticClass: "form-section",
              attrs: { "pl-3": "", xs12: "", md4: "" }
            },
            [
              _c(
                "div",
                { staticClass: "mx-3" },
                [
                  _c(
                    "v-flex",
                    { attrs: { "mb-3": "" } },
                    [
                      _c("v-layout", { staticClass: "title--text-custom" }, [
                        _c("div", { staticClass: "primary--text" }, [
                          _vm._v("2")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "secondary--text" }, [
                          _vm._v(".")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("h1", { staticClass: "primary--text" }, [
                        _vm._v("Équipement")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "base-control-label-vertical",
                    {
                      attrs: {
                        required: "",
                        label:
                          _vm.lblSetting.labelMaintenanceEquipementCategorie
                      }
                    },
                    [
                      _c("base-multi-select", {
                        attrs: {
                          required: "",
                          rules: _vm.dtRules.CategorieRules,
                          loading: _vm.isCategoriesLoading,
                          disabled: _vm.isUpdateTemplateMaintenance,
                          options: _vm.coEquipmentCategories,
                          icon: "",
                          "item-value": "id",
                          "item-text": "name",
                          multiple: false
                        },
                        model: {
                          value: _vm.FKEquipmentCategory,
                          callback: function($$v) {
                            _vm.FKEquipmentCategory = $$v
                          },
                          expression: "FKEquipmentCategory"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "base-control-label-vertical",
                    {
                      attrs: {
                        label:
                          _vm.lblSetting.labelMaintenanceEquipementSousCategorie
                      }
                    },
                    [
                      _c("base-multi-select", {
                        attrs: {
                          options: _vm.coEquipmentSubCategories,
                          icon: "",
                          "item-value": "id",
                          "item-text": "name",
                          multiple: false,
                          disabled:
                            _vm.isUpdateTemplateMaintenance ||
                            _vm.FKEquipmentCategory === null
                        },
                        model: {
                          value: _vm.FKEquipmentSubCategory,
                          callback: function($$v) {
                            _vm.FKEquipmentSubCategory = $$v
                          },
                          expression: "FKEquipmentSubCategory"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c("v-flex", { attrs: { "pl-3": "", xs12: "", md4: "" } }, [
            _c(
              "div",
              { staticClass: "mx-3" },
              [
                _c(
                  "v-flex",
                  { attrs: { "mb-3": "" } },
                  [
                    _c("v-layout", { staticClass: "title--text-custom" }, [
                      _c("div", { staticClass: "primary--text" }, [
                        _vm._v("3")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "secondary--text" }, [
                        _vm._v(".")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("h1", { staticClass: "primary--text" }, [
                      _vm._v("Options de récurrence")
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.FKEquipmentCategory && _vm.coAttributes.length
                  ? _c(
                      "base-control-label-vertical",
                      {
                        attrs: {
                          label: _vm.lblSetting.labelMaintenanceAttribute
                        }
                      },
                      [
                        _c("base-multi-select", {
                          attrs: {
                            disabled: _vm.isUpdateTemplateMaintenance,
                            options: _vm.coAttributes,
                            icon: "",
                            "item-value": "id",
                            "item-text": "name",
                            multiple: false
                          },
                          model: {
                            value: _vm.FKAttribute,
                            callback: function($$v) {
                              _vm.FKAttribute = $$v
                            },
                            expression: "FKAttribute"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.attributType === "date"
                  ? _c(
                      "base-control-label-vertical",
                      {
                        attrs: {
                          required: "",
                          label: _vm.lblSetting.labelMaintenanceIntervalType
                        }
                      },
                      [
                        _c("base-multi-select", {
                          attrs: {
                            required: "",
                            rules: _vm.dtRules.IntervalTypeRules,
                            disabled: _vm.isUpdateTemplateMaintenance,
                            options: _vm.coMaintenanceIntervalType,
                            icon: "",
                            "item-value": "id",
                            "item-text": "name",
                            multiple: false
                          },
                          model: {
                            value: _vm.FKMaintenanceIntervalType,
                            callback: function($$v) {
                              _vm.FKMaintenanceIntervalType = $$v
                            },
                            expression: "FKMaintenanceIntervalType"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.FKMaintenanceIntervalType
                  ? _c(
                      "base-control-label-vertical",
                      {
                        attrs: {
                          required: "",
                          label: _vm.lblSetting.labelMaintenanceInterval
                        }
                      },
                      [
                        _c("v-text-field", {
                          attrs: {
                            required: "",
                            rules: _vm.dtRules.IntervalRules,
                            type: "number",
                            suffix: _vm.intervalUnit,
                            solo: ""
                          },
                          model: {
                            value: _vm.interval,
                            callback: function($$v) {
                              _vm.interval = _vm._n($$v)
                            },
                            expression: "interval"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.FKMaintenanceIntervalType
                  ? _c(
                      "base-control-label-vertical",
                      {
                        attrs: {
                          label: _vm.lblSetting.labelMaintenanceAlertPreDelay
                        }
                      },
                      [
                        _c("v-text-field", {
                          attrs: {
                            type: "number",
                            suffix: _vm.alertUnit,
                            solo: ""
                          },
                          model: {
                            value: _vm.alertPreDelay,
                            callback: function($$v) {
                              _vm.alertPreDelay = _vm._n($$v)
                            },
                            expression: "alertPreDelay"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": "400" },
              model: {
                value: _vm.dialog.isOpen,
                callback: function($$v) {
                  _vm.$set(_vm.dialog, "isOpen", $$v)
                },
                expression: "dialog.isOpen"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-text",
                    {
                      staticClass: "pb-0",
                      staticStyle: { "font-size": "large" }
                    },
                    [_c("b", [_vm._v(_vm._s(_vm.dialog.title))])]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    { staticStyle: { "font-size": "medium" } },
                    [_vm._v(_vm._s(_vm.dialog.message))]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary", flat: "", round: "" },
                          on: { click: _vm.dialog.action }
                        },
                        [_vm._v(_vm._s(_vm.dialog.btnText))]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                            depressed: "",
                            round: "",
                            dark: ""
                          },
                          on: {
                            click: function($event) {
                              _vm.dialog.isOpen = false
                            }
                          }
                        },
                        [_vm._v("Continuer")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-87acbf6e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-87acbf6e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/profile/components/template-maintenance-modal-vertical/template.html
// module id = null
// module chunks = 